export const describeRefetchOutcome = (createdProfiles) => {
  const count = Array.isArray(createdProfiles) ? createdProfiles.length : 0

  if (count === 0) {
    return {
      severity: 'alert',
      message: 'Credit report refreshed — no new accounts were found',
    }
  }

  return {
    severity: 'success',
    message: `Credit report refreshed — ${count} ${count === 1 ? 'account' : 'accounts'} returned`,
  }
}
